import { Empty as AntdEmpty, EmptyProps } from 'antd'

export const Empty = (props: EmptyProps) => <AntdEmpty {...props} />
